import React from 'react';
import { getLifecycleClass } from "../../../tikit/ticketHelper";
import { hoverTitle } from '../table/emptyCell';

interface Props {
status: LifecycleStatus, 
phaseName: string,
extraClassNames?: string
id?: string
isPastPhase?: boolean;
/** The lists: the phase name as a tooltip only when the ribbon cuts it off (hoverTitle), not always. */
titleWhenCut?: boolean;
}

export const TicketLifecyclePhaseElement = ({status, phaseName, extraClassNames, id, isPastPhase, titleWhenCut}: Props) => {
    return (
    <div className={`phase-ribbon-container ${extraClassNames || ''}`} {...(titleWhenCut ? hoverTitle(phaseName) : { title: phaseName })}>
      <div className={`${isPastPhase ? 'phase-ribbon phase-ribbon-pastphase' : getLifecycleClass(status)}`} {...id && ({id: id})}>
        <div className="truncate" dir="ltr" style={{position: "relative"}}>{phaseName}</div>
      </div>
    </div>
    );
  };
  